export default "__VITE_ASSET__B19GL8gN__"